import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private authService: AuthenticationService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Verificar se é uma rota pública que não precisa de autenticação
        const isPublicRoute = this.isPublicRoute(req.url);
        
        return next.handle(this.addAuthToken(req)).pipe(
            catchError((error) => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    // Não fazer logout se for uma rota pública (permite que o componente trate o erro)
                    if (!isPublicRoute) {
                        this.authService.logout();
                    }
                    // return this.authService.refreshToken().pipe(
                    //     switchMap((newToken: string) => {
                    //         // Atualizar o token e refazer a requisição original com o novo JWT
                    //         localStorage.setItem('authToken', newToken);
                    //         return next.handle(this.addAuthToken(req));
                    //     }),
                    //     catchError((err) => {
                    //         // Caso o refresh token falhe, redirecionar para login
                    //         this.authService.logout();
                    //         return throwError(err);
                    //     })
                    // );
                }
                return throwError(error);
            })
        );
    }

    private isPublicRoute(url: string): boolean {
        // Lista de endpoints públicos que não precisam de autenticação
        const publicPaths = [
            '/api/clients/invite/',
            '/api/auth/signin',
            '/api/auth/signup',
            '/api/products/public/',
        ];
        return publicPaths.some(path => url.includes(path));
    }

    private addAuthToken(request: HttpRequest<any>): HttpRequest<any> {
        const token = localStorage.getItem('BearerToken');
        return token ? request.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
                'Cache-Control': 'no-cache',
                Pragma: 'no-cache',
                Expires: '0',
            },
        }) : request;
    }
}
